/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */

import log from '@atlassian/jira-common-util-logging/src/log.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { performGetRequest } from '@atlassian/jira-fetch/src/utils/requests.tsx';
import { createResource, type RouteResource } from '@atlassian/react-resource-router';
import { RESOURCE_TYPE_GIC_OPTIN_STATUS } from './resourceTypeGicOptinStatus.constants.tsx';

export type GicOptInStatusResourceData = {
	gicOptInStatus: {
		isEnabled: boolean;
		expiryTime?: number;
	} | null;
};

export const gicOptInStatusResources: RouteResource<GicOptInStatusResourceData> =
	createResource<GicOptInStatusResourceData>({
		type: RESOURCE_TYPE_GIC_OPTIN_STATUS,
		getKey: () => 'gic_optin_status',
		getData: async (): Promise<GicOptInStatusResourceData> => {
			let gicOptInStatus = null;

			try {
				if (fg('issue-create-stop-using-preference-api')) {
					gicOptInStatus = {
						isEnabled: true,
					};
				} else {
					gicOptInStatus = await performGetRequest(
						'/rest/greenhopper/1.0/profile/labs-panel/modern-gic-visibility',
					);
				}
				// oxlint-disable-next-line @typescript-eslint/no-explicit-any
			} catch (e: any) {
				if (e.statusCode !== 404) {
					log.safeErrorWithoutCustomerData(
						'spa.router.resources.navigation.gicVisibility',
						'getGICVisibility',
						e,
					);
				}
			}
			return {
				gicOptInStatus: gicOptInStatus ?? { isEnabled: false },
			};
		},
		maxAge: Number.MAX_VALUE,
		isCritical: true,
	});
